import React, { useState } from 'react'
import sortBy from 'lodash/sortBy'
import ReportTable from '../../components/reports/table'
import ReportFilter from '../../components/reports/filters'
import ReportDisplay from '../../components/reports/display'
import { ILeaveBalanceMonthlyReportProps } from './types'
import { getColumnsWithMonths, getMonthKey } from '@vacationtracker/shared/functions/export'
import { leaveBalanceMonthylReportColumns } from '@vacationtracker/shared/types/export'
import { UserStatus } from '@vacationtracker/shared/types/user'
import capitalize from 'lodash/capitalize'

const LeaveBalanceMonthlyReport: React.FC<ILeaveBalanceMonthlyReportProps> = ({
  companyData,
  data,
  total,
  page,
  loading,
  display,
  defaultFilters,
  onFiltersChange,
  onDisplayChange,
  loadNext,
  loadPrevious,
  download,
}) => {
  const [hideEmptyColumns, setHideEmptyColumns] = useState<boolean>(() => {
    const stored = localStorage.getItem('monthly-leave-balance-report_hideEmptyColumns')
    if (stored !== null) return stored === 'true'
    localStorage.setItem('monthly-leave-balance-report_hideEmptyColumns', 'true')
    return true
  })

  const handleHideEmptyColumnsChange = (value: boolean) => {
    setHideEmptyColumns(value)
    localStorage.setItem('monthly-leave-balance-report_hideEmptyColumns', String(value))
  }

  const filters = [
    { type: 'locationIds', options: companyData.getLocationList, label: 'Locations' },
    { type: 'departmentIds', options: companyData.getTeamList, label: 'Departments'},
    { type: 'labelIds', options: companyData.getLabels, label: 'Labels' },
    { type: 'userIds', options: companyData.getUsersFiltered.users, label: 'Users' },
    { type: 'leaveTypeIds', options: sortBy(companyData.getLeaveTypeList, 'position'), label: 'Leave Types' },
    { 
      type: 'userStatuses',
      options: (['ACTIVE', 'INACTIVE', 'DELETED'] as UserStatus[]).map(status => ({ id: status, name: capitalize(status) })),
      label: 'User Status',
    },
  ]

  const formatMonthlyColumnValues = (data) => {
    data.forEach(item => {
      item.amount.forEach(amount => {
        const key = getMonthKey(amount.month as number, amount.year as number)
        item[key] = { days: 0, hours: 0, raw: { days: amount.raw.days, hours: amount.raw.hours } }
      })
    })
    return data
  }

  return (
    <div>
      <ReportDisplay defaultDisplay={display} onDisplayChange={onDisplayChange}/>
      <ReportFilter filters={filters} onFilterChange={onFiltersChange} defaultSelectedValues={defaultFilters}/>
      <ReportTable 
        columnNames={getColumnsWithMonths(leaveBalanceMonthylReportColumns)}
        data={formatMonthlyColumnValues(data)}
        total={total}
        loadNext={loadNext}
        loadPrevious={loadPrevious}
        download={download}
        loading={loading}
        dateFormat={'YYYY-MM-DD'}
        display={display}
        page={page}
        reportType='monthly-leave-balance-report'
        editableColumns={true}
        hideEmptyColumns={hideEmptyColumns}
        onHideEmptyColumnsChange={handleHideEmptyColumnsChange}
      />
    </div>
  )
}

export default LeaveBalanceMonthlyReport
